<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.503 10.6577H19.4955C20.2731 10.6577 20.9023 11.2805 20.9023 12.0601C20.9023 12.8349 20.2628 13.4624 19.4955 13.4624H4.503C3.72699 13.4624 3.09766 12.8397 3.09766 12.0601C3.09766 11.2852 3.73724 10.6577 4.503 10.6577Z"
      fill="#8D5185"
      stroke="#8D5185"
      stroke-width="0.195312"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 34,
    },
    height: {
      type: Number,
      default: 34,
    },
  },
};
</script>

<style lang="scss" scoped></style>
